import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.css']
})
export class ConfigComponent {

  currentUser: any;

  users: any[];
  selectedUsers: any[];
  usersLoading: boolean = true;

  strains: any[];
  selectedStrains: any[];
  strainsLoading: boolean = true;

  config: any;

  selectedStartDate: Date;
  selectedEndDate: Date;

  days: number = 30;
  
  constructor(private dataService: DataService,
    private messageService: MessageService) { }

  ngOnInit() {
    this.dataService.getConfig().then(data => {
      this.config = data;

      this.dataService.getUsers().then(data => {
        this.users = data.map((s: { key: any; value: any; }) => ({key: s.key, name: s.value}));
        if (this.config !=null && this.config.selectedUsers != null)
          this.selectedUsers = this.users.filter(x =>  this.config.selectedUsers.includes(x.key));
        this.usersLoading = false;
      });

      this.dataService.getStrains().then(data => {
        this.strains = data.map((s: { key: any; value: any; }) => ({key: s.key, name: s.value}));
        if (this.config != null && this.config.selectedStrains != null)
          this.selectedStrains = this.strains.filter(x => this.config.selectedStrains.includes(x.key));
        this.strainsLoading = false;
      });

      if (this.config != null && this.config.selectedStartDate != null)
      {
        this.selectedStartDate = new Date(this.config.selectedStartDate);
      }

      if (this.config != null && this.config.selectedEndDate != null)
      {
        this.selectedEndDate = new Date(this.config.selectedEndDate);
      }
    });
  }

  Save($event:any) {
    var userKeys = this.selectedUsers != null ? this.selectedUsers.map(x => x.key).toString() : null;
    var strainKeys = this.selectedStrains != null ? this.selectedStrains.map(x => x.key).toString() : null;
    this.config = {"selectedUsers": userKeys, 
      "selectedStrains": strainKeys,
      "selectedStartDate": this.selectedStartDate,
      "selectedEndDate": this.selectedEndDate};
    console.log(JSON.stringify(this.config));
    this.dataService.updateConfig(this.config)
      .then(data => {
        this.messageService.add({severity:'success', summary:'Config saved'});
    });
  }

  PopulateData($event:any){
    this.messageService.add({severity:'info', summary:'Please wait, populating new data'});
    this.dataService.populateData(this.days).then(data => {
      this.messageService.add({severity:'success', summary:'New data populated'});
    });
  }
}
